import React from 'react'
import Text from './render/Text'
import Checkbox from './render/Checkbox'

import {checked} from '../formWizard/changeFunc'
import {sendOfd} from '../api/send'

import OfdCalc from './ofdCalc/App'

const formData = [[
  {
    id: 'name',
    type:'text',
    label: 'Наименование',
    placeholder: 'Наименование организации',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'inn',
    type:'text',
    label: 'ИНН',
    placeholder: 'ИНН организации',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'kpp',
    type:'text',
    label: 'КПП',
    placeholder: 'КПП организации',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'contact',
    type:'text',
    label: 'Контактное лицо (ФИО)',
    placeholder: 'Контактное лицо (ФИО)',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'phone',
    type:'text',
    label: 'Телефон',
    placeholder: 'Телефон',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'email',
    type:'text',
    label: 'E-mail',
    placeholder: 'E-mail',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'registerCount',
    type:'text',
    label: 'Количество касс',
    placeholder: 'Количество касс',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}],
    value: '1'
  },
  {
    id: 'promoCode',
    type: 'text',
    label: 'Промокод',
    placeholder: 'Промокод'
  }
],
[
  {
    id: 'mode',
    type: 'text',
    value: 'kkt'
  },
  {
    id: 'register',
    type: 'text',
    value: 'atol90F'
  },
  {
    id: 'fiskal',
    type: 'checkbox',
    value: false
  },
  {
    id: 'activationCode',
    type: 'checkbox',
    value: false
  },
  {
    id: 'kktactivation',
    type: 'checkbox',
    value: false
  },
  {
    id: 'lkofdregistration',
    type: 'checkbox',
    value: false
  },
  {
    id: 'registrationwithoutfns',
    type: 'checkbox',
    value: false
  },
  {
    id: 'techicalsupport',
    type: 'checkbox',
    value: false
  },
  {
    id: 'po',
    type: 'checkbox',
    value: false
  },
  {
    id: 'ofdcode',
    type: 'checkbox',
    value: false
  },
  {
    id: 'abonent',
    type: 'checkbox',
    value: false
  },
  {
    id: 'docexpert',
    type: 'checkbox',
    value: false
  },
  {
    id: 'jacarta',
    type: 'checkbox',
    value: false
  },
  {
    id: 'signature',
    type: 'checkbox',
    value: false
  },
  {
    id: 'techicalLkFns',
    type: 'checkbox',
    value: false
  },
  {
    id: 'techicalLkOfd',
    type: 'checkbox',
    value: false
  },
  {
    id: 'fiskalizationAndFNS',
    type: 'checkbox',
    value: false
  },
  {
    id: 'connectOfd',
    type: 'checkbox',
    value: false
  },
  {
    id: 'kktSoft',
    type: 'checkbox',
    value: false
  },
  {
    id: 'delivery',
    type: 'checkbox',
    value: false
  }
],
[
  {
    id: 'contractPost',
    type:'text',
    label: 'Должность',
    placeholder: 'Должность',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'contractFIO',
    type:'text',
    label: 'ФИО (полностью)',
    placeholder: 'ФИО (полностью)',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'contractAddress',
    type:'text',
    label: 'Адрес',
    placeholder: 'Адрес',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'contractPhone',
    type:'text',
    label: 'Телефон',
    placeholder: 'Телефон',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'bankClient',
    type:'text',
    label: 'Расчетный счет',
    placeholder: 'Расчетный счет',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'bankName',
    type:'text',
    label: 'Банк',
    placeholder: 'Банк',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'bankAccount',
    type:'text',
    label: 'Кор.счет',
    placeholder: 'Кор.счет',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'bankBIK',
    type:'text',
    label: 'БИК',
    placeholder: 'БИК',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
]]

function previousButton({onClick}) {
  return <a className="button is-large is-danger" onClick={onClick}>Назад</a>
}

function nextButton({onClick}) {
  return <a className="button is-fullwidth is-large is-success" onClick={onClick}>Продолжить</a>
}

function finishButton({onClick}) {
  return <a className="button is-fullwidth is-large is-success" onClick={onClick}>Отправить</a>
}

const typeRender = {
  text: {component: Text},
  checkbox: {component: Checkbox, onChange: checked},
  previousButton: {component: previousButton},
  nextButton: {component: nextButton},
  finishButton: {component: finishButton}
}

const Ofd = ({fields, previousButton, nextButton}) => {
  return(
    <div className="container">
      <div className="columns">
        <div className="column is-12 has-text-centered">
          <h1 className="title is-1">Астрал.ОФД</h1>
        </div>
      </div>
      <div className="columns">
        <div className="column is-6 is-offset-3">
          {fields.name}
          {fields.inn}
          {fields.kpp}
          {fields.contact}
          {fields.phone}
          {fields.email}
          {fields.registerCount}
          {fields.promoCode}
          <div className="columns is-gapless">
            <div className="column is-4">
              {previousButton}
            </div>
            <div className="column is-7">
              {nextButton}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

/**
const Ofd2 = ({fields, previousButton, nextButton}) => {
  return(
    <div className="container">
      <div className="columns">
        <div className="column is-12 has-text-centered">
          <h1 className="title is-1">Астрал.ОФД</h1>
        </div>
      </div>
      <div className="columns">
        <div className="column is-12 has-text-centered">
          <h3 className="title is-3">Дополнительные услуги</h3>
        </div>
      </div>
      <div className="columns">
        <div className="column is-10">
          <div className="columns is-gapless">
            <div className="column is-4">
            </div>
            <div className="column is-7">
              <p>Установите "галочку" напротив выбранной услуги</p>
            </div>
          </div>
          {fields.esignature}
          {fields.etoken}
          {fields.workForOnlineRegisterInFNS}
          {fields.registerWithoutFNS}
          {fields.lkRegistration}
          {fields.kktRegistration}
          {fields.kktSupply}
          {fields.fiskalSupply}
          {fields.torgPO}
          <div className="columns is-gapless">
            <div className="column is-4">
              {previousButton}
            </div>
            <div className="column is-7">
              {nextButton}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

*/

const Ofd3 = ({fields, previousButton, nextButton}) => {
  return(
    <div className="container">
      <div className="columns">
        <div className="column is-12 has-text-centered">
          <h1 className="title is-1">Астрал.ОФД</h1>
        </div>
      </div>
      <div className="columns">
        <div className="column is-12 has-text-centered">
          <h3 className="title is-3">Реквизиты для договора</h3>
        </div>
      </div>
      <div className="columns">
        <div className="column is-10">
          <div className="columns is-gapless">
            <div className="column is-4">
            </div>
            <div className="column is-7">
              <p>Подписант</p>
            </div>
          </div>
          
          {fields.contractPost}
          {fields.contractFIO}
          {fields.contractAddress}
          {fields.contractPhone}
          <div className="columns is-gapless">
            <div className="column is-4">
            </div>
            <div className="column is-7">
              <p>Банковские реквизиты</p>
            </div>
          </div>
          
          {fields.bankClient}
          {fields.bankName}
          {fields.bankAccount}
          {fields.bankBIK}
          <div className="columns is-gapless">
            <div className="column is-4">
              {previousButton}
            </div>
            <div className="column is-7">
              {nextButton}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

class Ofd5 extends React.Component {
  constructor(props) {
    super(props)

    this.changeTest = this.changeTest.bind(this)
  }
  changeTest() {
    this.props.changeFieldinFormState('mode', {value: 'key'})
  }
  render() {
    const {fields, fieldsState, previousButton, changeFieldinFormState, nextButton} = this.props
    return(
      <div className="container">
        <div className="columns">
          <div className="column is-12 has-text-centered">
            <h1 className="title is-1" onClick={this.changeTest}>Астрал.ОФД</h1>
          </div>
        </div>
        <div className="columns">
          <div className="column is-10">
            <OfdCalc changeFieldinFormState={changeFieldinFormState} />
            <div className="columns is-gapless">
              <div className="column is-4">
                {previousButton}
              </div>
              <div className="column is-7">
                {nextButton}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

/**
const Ofd4 = ({fields, previousButton, nextButton, chooseEconomBundle, chooseOptimalBundle, chooseMobileBundle, chooseManualFeatures}) => {
  return(
    <div className="container">
      <div className="columns">
        <div className="column is-12 has-text-centered">
          <h1 className="title is-1">Астрал.ОФД</h1>
        </div>
      </div>
      <div className="columns">
        <div className="column is-12 has-text-centered">
          <h3 className="title is-3">Он-лайн касса «Под Ключ»</h3>
        </div>
      </div>
      <div className="columns">
        <div className="column column is-10 is-offset-1">
          <table className="table is-bordered content">
            <thead>
              <tr>
                <th>Комплект «ЭКОНОМ»</th>
                <th>Комплект «ОПТИМАЛЬНЫЙ»</th>
                <th>Комплект «МОБИЛЬНЫЙ»</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span style={{textDecoration: 'line-through'}}>47340 руб.</span> –> <span style={{fontSize: '16pt', color: '#4fa800'}}>27250 руб</span></td>
                <td><span style={{textDecoration: 'line-through'}}>62340 руб</span> -> <span style={{fontSize: '16pt', color: '#4fa800'}}>42250 руб.</span></td>
                <td><span style={{textDecoration: 'line-through'}}>72640 руб</span> -> <span style={{fontSize: '16pt', color: '#4fa800'}}>53250 руб</span></td>
              </tr>
              <tr>
                <td>
                  <p>Состав комплекта:</p>
                  <ul>
                    <li>ККТ</li>
                    <li>Фискальный накопитель</li>
                    <li>Код активации ККТ на услугу ОФД</li>
                    <li>Регистрация ЛК у ОФД и заключение договора с ОФД</li>
                    <li>Регистрация/перерегистрация онлайн кассы без посещения ФНС</li>
                    <li>Техническая настройка рабочего места (для регистрации онлайн-касс в ФНС, для работы с ЛК ОФД)</li>
                    <li>Программное обеспечение для учета и автоматизации, интегрированное с онлайн кассой (лицензия, установка, настройка, первый запуск)</li>
                    <li>Регистрации и активация кода ККТ у ОФД (подключение кассы к услуге ОФД)</li>
                    <li>Абонентское обслуживание на год при работе с ОФД (информационно-консультационное и техническое)</li>
                    <li>Экспертиза документов КЭП для доступа на сайт ФНС и сайт ОФД</li>
                    <li>Защищенный сертифицированный носитель USB-токен JaCarta LT</li>
                  </ul>
                </td>
                <td>
                  <p>Состав комплекта:</p>
                  <ul>
                    <li><strong>Мини компьютер</strong></li>
                    <li>ККТ</li>
                    <li>Фискальный накопитель</li>
                    <li>Код активации ККТ на услугу ОФД</li>
                    <li>Регистрация ЛК у ОФД и заключение договора с ОФД</li>
                    <li>Регистрация/перерегистрация онлайн кассы без посещения ФНС</li>
                    <li>Техническая настройка рабочего места (для регистрации онлайн-касс в ФНС, для работы с ЛК ОФД)</li>
                    <li>Программное обеспечение для учета и автоматизации, интегрированное с онлайн кассой (лицензия, установка, настройка, первый запуск)</li>
                    <li>Регистрации и активация кода ККТ у ОФД (подключение кассы к услуге ОФД)</li>
                    <li>Абонентское обслуживание на год при работе с ОФД (информационно-консультационное и техническое)</li>
                    <li>Экспертиза документов КЭП для доступа на сайт ФНС и сайт ОФД</li>
                    <li>Защищенный сертифицированный носитель USB-токен JaCarta LT</li>
                  </ul>
                </td>
                <td>
                  <p>Состав комплекта:</p>
                  <ul>
                    <li><strong>Мини компьютер</strong></li>
                    <li><strong>Мобильный ККТ</strong></li>
                    <li>Фискальный накопитель</li>
                    <li>Код активации ККТ на услугу ОФД</li>
                    <li>Регистрация ЛК у ОФД и заключение договора с ОФД</li>
                    <li>Регистрация/перерегистрация онлайн кассы без посещения ФНС</li>
                    <li>Техническая настройка рабочего места (для регистрации онлайн-касс в ФНС, для работы с ЛК ОФД)</li>
                    <li>Программное обеспечение для учета и автоматизации, интегрированное с онлайн кассой (лицензия, установка, настройка, первый запуск)</li>
                    <li>Регистрации и активация кода ККТ у ОФД (подключение кассы к услуге ОФД)</li>
                    <li>Абонентское обслуживание на год при работе с ОФД (информационно-консультационное и техническое)</li>
                    <li>Экспертиза документов КЭП для доступа на сайт ФНС и сайт ОФД</li>
                    <li>Защищенный сертифицированный носитель USB-токен JaCarta LT</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td><button className="button is-success is-large is-fullwidth" onClick={chooseEconomBundle}>Выбрать</button></td>
                <td><button className="button is-success is-large is-fullwidth" onClick={chooseOptimalBundle}>Выбрать</button></td>
                <td><button className="button is-success is-large is-fullwidth" onClick={chooseMobileBundle}>Выбрать</button></td>
              </tr>
            </tbody>
          </table>
          <p className="has-text-centered"><a href="http://ed25.ru" style={{color: '#4fa800', fontSize: '18pt'}} onClick={chooseManualFeatures}>Выбрать индивидуальные услуги</a></p>
        </div>
      </div>
    </div>
  )
}
*/

const sendData = formData => {
  sendOfd(formData)
        .then(result => {
          window.location.replace('http://ed25.ru/forms/#/congrats')
        })
        .catch(err => {
          console.log(err)
        })
}

export {Ofd, Ofd3, Ofd5, formData, typeRender, sendData}


// WEBPACK FOOTER //
// ./src/components/Ofd.js